/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { RouterState, ROUTES } from "@bms/common";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { useModal } from "context/modal";

import { Dialog } from "../Dialog";
import { MediaButton } from "../MediaButton";

import "./LoginModal.scss";

export const LoginModal = () => {
  const { t } = useTranslation();
  const { dismissModal } = useModal();

  return (
    <Dialog
      wrapClassName="LoginModal"
      footer={null}
      destroyOnClose
      visible
      onCancel={dismissModal}
    >
      <span className="LoginModal__Header">{t("LOGIN_REQUIRED_MESSAGE")}</span>
      <div className="LoginModal__Actions">
        <Link
          to={{
            pathname: ROUTES.LOGIN,
            state: new RouterState(location.pathname + location.search),
          }}
          onClick={dismissModal}
        >
          <MediaButton type="button" variant="primary">
            {t("LOGIN_REQUIRED_ACTION")}
          </MediaButton>
        </Link>
        <MediaButton type="button" variant="secondary" onClick={dismissModal}>
          {t("LOGIN_REQUIRED_CLOSE")}
        </MediaButton>
      </div>
    </Dialog>
  );
};
